import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateManifestComponent = loadable(
  () => import("../../components/Manifest/CreateManifest")
);
import { useNavigate } from "react-router-dom";
const CreateManifest = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["manifest"],
    navigateURL: "",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}`;
    let formData = {
      ...values,
      type:"manifest"
    };
    console.log(formData)
    try {
      const res = await mutateAsync({ url, formData, setError });
      if(res.status == 201){
        console.log(res?.data)
        navigate(`/manifest/edit/${res?.data?.id}`)
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">
          Create Manifest
        </span>
      </div>
      <CreateManifestComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};
export default CreateManifest;
